import React from 'react'
import * as request from 'superagent'
import moment from 'moment'
import DefaultPicture from '../../img/commons/default_picture.png'
import warningData from '../../img/icons/general-icons/icon_warning.png'
import PrintReport from '../../img/icons/general-icons/icono_print.png'
import SimulatorIC from '../../img/icons/general-icons/icono_simulador.png'
import SendReport from '../../img/icons/general-icons/icono_email.png'
import LZString from 'lz-string'
import { Link } from 'react-router'
import { ToastContainer, ToastMessage } from 'react-toastr'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class DashboardPersonalData extends React.Component {
  hexEncode (str) {
    var hex, i
    var result = ''
    for (i = 0; i < str.length; i++) {
      hex = str.charCodeAt(i).toString(16)
      result += ('000' + hex).slice(-4)
    }
    return result
  }

  sendFunction () {
    let endpoint = 'https://resultados.sicor.com.co/api/registrourl/'
    let obj = {
        cc : this.props.data.numeroDocumento,
        url : arguments[0]
      }

    request
      .post(endpoint)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization','iyvmG3ZFjMuinCYUeVgc')
      .send(obj)
      .end((err, res) => {
        if (err) console.log(err)
        else console.log(res)
        this.refs.container.success('Enviamos el simulador a la plataforma de resultados', '', {
          closeButton: true
        })
      })
  }

  getStyles () {
    var profilePicture = this.props.data.patientImage ? this.props.data.patientImage : DefaultPicture
    let styles = {
      img: {
        'background': 'url(' + profilePicture + ')'
      }
    }
    return Object.assign({}, styles.img)
  }
  render () {
    var profilePicture = this.props.data.patientImage ? this.props.data.patientImage : DefaultPicture
    var agePatient = this.props.data.patientAge + ' años '
    var urlPaciente = 'printableDashboard/' + this.props.data.numeroDocumento
    var urlDoctor = 'printableDiabetes/' + this.props.data.numeroDocumento
    var obj = {
      arterialAge: this.props.data.arterialAge,
      biologicalAge: this.props.data.biologicalAge,
      chart1: this.props.data.chart1,
      chart2: this.props.data.chart2,
      fx_reserve: this.props.data.fx_reserve,
      percent_lost_capacity: this.props.data.percent_lost_capacity,
      medicalBMIData: this.props.data.medicalBMIData,
      medicalBalanceNeur: this.props.data.medicalData.balanceNeuroMuscularT,
      medicalCol: this.props.data.medicalCol,
      medicalColGlicemia: this.props.data.medicalColGlicemia,
      medicalColHDL: this.props.data.medicalColHDL,
      medicalColLDL: this.props.data.medicalColLDL,
      medicalColTotal: this.props.data.medicalColTotal,
      medicalColTrigliceridos: this.props.data.medicalColTrigliceridos,
      medicalCreatinina: this.props.data.medicalCreatinina,
      medicalData: this.props.data.medicalData,
      medicalFrecuenciaC: this.props.data.medicalFrecuenciaC,
      medicalPAParado: this.props.data.medicalPAParado,
      medicalPASentado: this.props.data.medicalPASentado,
      medicalPeso: this.props.data.medicalPeso,
      numeroDocumento: this.props.data.numeroDocumento,
      patientAge: this.props.data.patientAge,
      patientBirthDay: this.props.data.patientBirthDay,
      patientGender: this.props.data.patientGender,
      patientFullName: this.props.data.patientFullName
    }
    let str = JSON.stringify(obj)
    str = LZString.compress(str)
    str = this.hexEncode(str)
    var url = (window.location.hostname === 'localhost') ? 'http://localhost:8001/?' : window.location.origin + '/simulator/?'
    var cloneObj = url + str
    // console.log(moment().format("DD-MM-YYYY HH:MM:ss"),this.props.state)
    this.props
    return (
      <div className='basic-data-container'>
      <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <div className='patient-personal-information'>
          <div className='image-container'>
            <div id='photo' className='patient-photo' style={this.getStyles()}> </div>
          </div>
          <div className='data-container'>
            <label className='data' id='patientFullName'>{this.props.data.patientFullName}</label>
            <label className='data' id='patientDocument'>{this.props.data.patientIdentification}</label>
            <label className='data data-text-label' id='patientAge'>Edad: { agePatient }{(this.props.data.patientAge < 25 || this.props.data.patientAge > 80) ? <img className='range-warning-image' src={warningData}/> : null}</label>
            {this.props.state.muerto ?
             <label className='dead'>Falleció</label> : ''}
            {this.props.state.muerto ?  <label className='date'> {this.props.state.date_muerte}</label>: ''}
          </div>
        </div>
        <div className='generate-report'>
          {/* <div className='link-report'>
            <Link to={urlPaciente} className='link-report-data' target='_blank'>
              <img className='report-img' src={PrintReport}/>
              <span>Informe paciente</span>
            </Link>
          </div>
          <div className='link-report'>
            <Link to={urlDoctor} className='link-report-data' target='_blank'>
              <img className='report-img' src={PrintReport}/>
              <span>Informe doctor</span>
            </Link>
          </div> */}
          <div className='link-report'>
            <a href={cloneObj} className='link-report-data' target='_blank'>
              <img className='report-img' src={SimulatorIC}/>
              <span>Simulación</span>
            </a>
          </div>
          <div className='link-report'>
            <div className='link-report-data' onClick={this.sendFunction.bind(this, cloneObj)}>
              <img className='report-img' src={SimulatorIC}/>
              <span>Enviar</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
DashboardPersonalData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardBasicData.js